import { useSystemStore } from "components/PageHeader/systemStore";
import React from "react";

type Props = {
  size?: number;
  color?: string;
  classes?: string;
};

// 817E8C
// 19093A

export const IconEnter: React.FC<Props> = ({
  size = 24,
  color = "#817E8C",
  classes = "fill-neutral-60",
}) => {
  const theme = useSystemStore((state) => state.theme);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5.66602 10.8333L8.08268 13.25C8.23546 13.4028 8.31185 13.5972 8.31185 13.8333C8.31185 14.0694 8.23546 14.2639 8.08268 14.4167C7.9299 14.5694 7.73546 14.6458 7.49935 14.6458C7.26324 14.6458 7.06879 14.5694 6.91602 14.4167L3.08268 10.5833C2.99935 10.5 2.94032 10.4097 2.9056 10.3125C2.87088 10.2153 2.85352 10.1111 2.85352 10C2.85352 9.88889 2.87088 9.78472 2.9056 9.6875C2.94032 9.59028 2.99935 9.5 3.08268 9.41666L6.91602 5.58333C7.06879 5.43055 7.26324 5.35416 7.49935 5.35416C7.73546 5.35416 7.9299 5.43055 8.08268 5.58333C8.23546 5.73611 8.31185 5.93055 8.31185 6.16666C8.31185 6.40278 8.23546 6.59722 8.08268 6.75L5.66602 9.16666H15.8327V6.66666C15.8327 6.43055 15.9125 6.23264 16.0723 6.07291C16.232 5.91319 16.4299 5.83333 16.666 5.83333C16.9021 5.83333 17.1 5.91319 17.2598 6.07291C17.4195 6.23264 17.4993 6.43055 17.4993 6.66666V9.16666C17.4993 9.625 17.3362 10.0174 17.0098 10.3437C16.6834 10.6701 16.291 10.8333 15.8327 10.8333H5.66602Z"
        fill={theme == "dark" ? "#C29FEE" : color}
      />
    </svg>
  );
};
